/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps } from 'framework/ui/field';
import { PAYROLL_REPORT_STATUSES_OPTIONS } from 'domain/finance/payroll/generatedPayrolls/useGeneratedPayrollsService';

const PayrollReportsStatusField = (props: FieldProps) => {
  return <EnumField options={PAYROLL_REPORT_STATUSES_OPTIONS} {...props} />;
};

export default PayrollReportsStatusField;
